import { useSearchParams } from 'react-router-dom';
import { Dispatch, SetStateAction, useState } from 'react';

type usePaginationReturnType = [
  number,
  Dispatch<SetStateAction<number>>,
  ReturnType<typeof useSearchParams>[1]
];

export function usePagination(): usePaginationReturnType {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultPage = Number(searchParams.get('offset')) || 1;
  const [page, setPage] = useState(defaultPage);
  return [page, setPage, setSearchParams];
}
